import React from 'react';

import { Col, Row } from 'react-bootstrap';

import { useReview } from 'reviews2/feed/review-yeti/Review.store';
import { Label } from 'reviews2/feed/review-yeti/Review.types';
import { setLabel } from 'reviews2/Reviews.api';

const MRActions = ({ actionMRRenderer }: any) => {
    const [{ review }] = useReview();

    const flagCallback = () => {
        if (review) {
            return setLabel(review.r4e_tenant_id, review.document_id, Label.Flagged);
        }
        return Promise.reject(new Error('surveyResult not found'));
    };

    const publishCallback = () => {
        if (review) {
            return setLabel(review.r4e_tenant_id, review.document_id, Label.Published);
        }
        return Promise.reject(new Error('surveyResult not found'));
    };

    if (review) {
        return (
            <Row>
                <Col xs={3} />
                <Col>
                    {actionMRRenderer &&
                        actionMRRenderer({
                            isFlagged: Boolean(review?.r4e_label_ids?.includes(Label.Flagged)),
                            isPublished:
                                Boolean(review?.r4e_label_ids?.includes(Label.Published)) ||
                                !review.source?.publishable,
                            flagCallback,
                            publishCallback,
                        })}
                </Col>
            </Row>
        );
    }
    return null;
};

export default MRActions;
